<template>
    <div class="buttons-type-multiselect two-btns">
        <div class="item" v-for="map in locations" @click="$emit('location', map.id)">
            <input type="radio" class="rad" :id="`map-${map.id}`" :value="map.id" v-model="location">
            <label :for="`map-${map.id}`">
                <GoogleMap
                 :input_map_height="`9.1875rem`"
                 :input_map_center="{ lat : parseFloat(map.lat), lng : parseFloat(map.lng) }"
                 :input_map_zoom="16"
                 :input_map_center_default="true"
                 :input_marker_image="`/img/marker-blue.png`"
                ></GoogleMap>

                <div class="ttl">
                    <i class="fas fa-map-marker-alt"></i>{{ map.name }}</div>
                <div class="arrow"><img src="/img/check-4.svg" alt=""></div>
            </label>
        </div>
    </div>
</template>

<script>
    import GoogleMap from "../../../../../../../resources/js/components/GoogleMap";

    export default {
        name: "BookingMap",
        components: { GoogleMap },
        props: {
            map_location: Number,
            locations: Array,
        },
        data() {
            return {
                location: this.map_location,
            }
        }
    }
</script>
